import { observable } from 'mobx';

export class RentsReportParams {
  @observable year: number = 0;
}
